import { render, staticRenderFns } from "./Tenants.vue?vue&type=template&id=624820ba&scoped=true"
import script from "./Tenants.vue?vue&type=script&lang=js"
export * from "./Tenants.vue?vue&type=script&lang=js"
import style0 from "./Tenants.vue?vue&type=style&index=0&id=624820ba&prod&lang=css"
import style1 from "./Tenants.vue?vue&type=style&index=1&id=624820ba&prod&lang=scss"
import style2 from "./Tenants.vue?vue&type=style&index=2&id=624820ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624820ba",
  null
  
)

export default component.exports